var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c(
        "a-card",
        {
          staticStyle: {
            "box-sizing": "border-box",
            "border-radius": "0 !important",
          },
        },
        [
          _c("div", { staticClass: "wps", style: { background: "#f0f2f5" } }, [
            _c("div", { staticClass: "biaoti" }, [
              _c("div", { staticClass: "boxw" }, [
                _c("img", {
                  staticStyle: {
                    "margin-top": "-14px",
                    "padding-right": "10px",
                  },
                  attrs: { src: _vm.httplogo, width: "100px", height: "100px" },
                }),
              ]),
              _vm._v(" " + _vm._s(_vm.configdata.projectname) + " "),
            ]),
          ]),
          !_vm.appId
            ? _c("a-divider", [_vm._v("请选择应用APPID")])
            : _vm.noConfigText
            ? _c("a-divider", [_vm._v("您尚未配置任何支付方式")])
            : _vm._e(),
          _vm.payTestShow()
            ? _c(
                "div",
                { staticClass: "paydemo", staticStyle: { width: "100%" } },
                [
                  _c(
                    "div",
                    { staticClass: "paydemo-type-content" },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showTitle("WX"),
                              expression: "showTitle('WX')",
                            },
                          ],
                          staticClass: "paydemo-type-name article-title",
                        },
                        [_vm._v("微信支付")]
                      ),
                      _c("div", { staticClass: "paydemo-type-body" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.appPaywayList.indexOf("WX_NATIVE") >= 0,
                                expression:
                                  "appPaywayList.indexOf('WX_NATIVE') >= 0",
                              },
                            ],
                            staticClass: "paydemo-type color-change",
                            class: { this: _vm.currentWayCode === "WX_NATIVE" },
                            on: {
                              click: function ($event) {
                                return _vm.changeCurrentWayCode(
                                  "WX_NATIVE",
                                  "codeImgUrl"
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "paydemo-type-img",
                              attrs: {
                                src: require("@/assets/payTestImg/wx_native.svg"),
                              },
                            }),
                            _c("span", { staticClass: "color-change" }, [
                              _vm._v("微信二维码"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.appPaywayList.indexOf("WX_BAR") >= 0,
                                expression:
                                  "appPaywayList.indexOf('WX_BAR') >= 0",
                              },
                            ],
                            staticClass: "paydemo-type color-change",
                            class: { this: _vm.currentWayCode === "WX_BAR" },
                            on: {
                              click: function ($event) {
                                return _vm.changeCurrentWayCode("WX_BAR", "")
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "paydemo-type-img",
                              attrs: {
                                src: require("@/assets/payTestImg/wx_bar.svg"),
                              },
                            }),
                            _c("span", { staticClass: "color-change" }, [
                              _vm._v("微信条码"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.appPaywayList.indexOf("WX_JSAPI") >= 0,
                                expression:
                                  "appPaywayList.indexOf('WX_JSAPI') >= 0",
                              },
                            ],
                            staticClass: "paydemo-type color-change",
                            class: { this: _vm.currentWayCode === "WX_JSAPI" },
                            on: {
                              click: function ($event) {
                                return _vm.changeCurrentWayCode(
                                  "WX_JSAPI",
                                  "codeImgUrl"
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "paydemo-type-img",
                              attrs: {
                                src: require("@/assets/payTestImg/wx_jsapi.svg"),
                              },
                            }),
                            _c("span", { staticClass: "color-change" }, [
                              _vm._v("公众号/小程序"),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.appPaywayList.indexOf("WX_H5") >= 0,
                                expression:
                                  "appPaywayList.indexOf('WX_H5') >= 0",
                              },
                            ],
                            staticClass: "paydemo-type-h5",
                            class: { this: _vm.currentWayCode === "WX_H5" },
                            on: {
                              click: function ($event) {
                                return _vm.changeCurrentWayCode(
                                  "WX_H5",
                                  "payurl"
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "paydemo-type-img",
                              attrs: {
                                src: require("@/assets/payTestImg/wx_h5.svg"),
                              },
                            }),
                            _c("span", { staticClass: "color-change" }, [
                              _vm._v("微信H5"),
                            ]),
                          ]
                        ),
                      ]),
                      _c(
                        "a-row",
                        { staticStyle: { "margin-bottom": "20px" } },
                        [
                          _c(
                            "a-col",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { span: 24 },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.configdata.usbkeyimg,
                                  width: "250px",
                                  height: "90px",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("a-row"),
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form",
                                {
                                  attrs: {
                                    form: _vm.form,
                                    "label-col": { span: 5 },
                                    "wrapper-col": { span: 18 },
                                  },
                                  on: { submit: _vm.handleSubmit },
                                },
                                [
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "购买项目" } },
                                    [
                                      _c(
                                        "a-radio-group",
                                        {
                                          attrs: {
                                            name: "radioGroup",
                                            "default-value": 1,
                                          },
                                        },
                                        [
                                          _c(
                                            "a-radio",
                                            { attrs: { value: 1 } },
                                            [
                                              _vm._v("介质"),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(_vm.tobonumber)
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "text-decoration":
                                                          "line-through",
                                                        "font-size": "8px",
                                                      },
                                                    },
                                                    [_vm._v("（原价49）")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-tooltip",
                                        { attrs: { placement: "top" } },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _c("span", [
                                              _vm._v(
                                                "灌装流程说明：企业在此下单后，请再自行前往证书运维管理平台上提交证书申请。"
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "a-radio-group",
                                            {
                                              attrs: {
                                                name: "radioGroup",
                                                "default-value": 1,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-radio",
                                                { attrs: { value: 1 } },
                                                [
                                                  _vm._v(" 灌装代办"),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "red",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "￥" +
                                                          _vm._s(_vm.tobonum)
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticStyle: {
                                                            color: "#999",
                                                            "text-decoration":
                                                              "line-through",
                                                            "font-size": "8px",
                                                          },
                                                        },
                                                        [_vm._v("（原价24）")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "a-checkbox",
                                        {
                                          attrs: { checked: _vm.checkeddef },
                                          on: { change: _vm.onChange1 },
                                        },
                                        [
                                          _vm._v(
                                            " 省心服务(介质灌装完成邮寄到手)"
                                          ),
                                          _c(
                                            "span",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("￥" + _vm._s(_vm.Byyouji))]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "a-checkbox",
                                        { attrs: { checked: "checkeddef" } },
                                        [_vm._v("含一年技术服务")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "购买数量" } },
                                    [
                                      _c("a-input-number", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "totalnum",
                                              {
                                                initialValue: 1,
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: "购买数量!",
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "['totalnum', { initialValue:1,rules: [{ required: true, message: '购买数量!' }] }]",
                                          },
                                        ],
                                        attrs: {
                                          id: "inputNumber",
                                          min: 1,
                                          max: 100,
                                        },
                                        on: { change: _vm.onChanges },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "购买单位" } },
                                    [
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "company",
                                              {
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: "请输入购买单位!",
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "['company', { rules: [{ required: true, message: '请输入购买单位!' }] }]",
                                          },
                                        ],
                                        attrs: {
                                          placeholder: "请输入购买单位全称",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "信用代码" } },
                                    [
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "yscode",
                                              _vm.validatorRules.yscode,
                                              {
                                                rules: [
                                                  {
                                                    required: true,
                                                    message:
                                                      "请输入统一社会信用代码!",
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "['yscode',validatorRules.yscode, { rules: [{ required: true, message: '请输入统一社会信用代码!' }] }]",
                                          },
                                        ],
                                        attrs: {
                                          placeholder: "请输入统一社会信用代码",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "经办人" } },
                                    [
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "name",
                                              {
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: "请输入经办人!",
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "['name', { rules: [{ required: true, message: '请输入经办人!' }] }]",
                                          },
                                        ],
                                        attrs: {
                                          placeholder: "请输入经办人姓名",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "手机号码" } },
                                    [
                                      _c("a-input", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "phone",
                                              _vm.validatorRules.phone,
                                              {
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: "请输入手机号码!",
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "['phone',validatorRules.phone, { rules: [{ required: true, message: '请输入手机号码!' }] }]",
                                          },
                                        ],
                                        attrs: {
                                          placeholder: "请输入11位手机号码",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "a-form",
                                  {
                                    attrs: {
                                      form: _vm.form,
                                      "label-col": { span: 5 },
                                      "wrapper-col": { span: 12 },
                                    },
                                  },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "是否开票" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "baseline",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-radio-group",
                                              {
                                                staticStyle: {
                                                  "margin-top": "8px",
                                                },
                                                attrs: {
                                                  name: "radioGroup",
                                                  "default-value": 2,
                                                },
                                                model: {
                                                  value: _vm.valueaw,
                                                  callback: function ($$v) {
                                                    _vm.valueaw = $$v
                                                  },
                                                  expression: "valueaw",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-tooltip",
                                                  {
                                                    attrs: { placement: "top" },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "发票一到三个工作日，会发到您填写的邮箱"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "a-radio",
                                                      { attrs: { value: 1 } },
                                                      [_vm._v(" 是 ")]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _c(
                                                  "a-radio",
                                                  {
                                                    attrs: {
                                                      value: 2,
                                                      disabled: "true",
                                                    },
                                                  },
                                                  [_vm._v(" 否 ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.valueaw == 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "仅支持电子增值税普通发票"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.valueaw == 2
                                              ? _c("div", {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "电子邮箱" } },
                                      [
                                        _c("a-input", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "email",
                                                _vm.validatorRules.email,
                                              ],
                                              expression:
                                                "['email',validatorRules.email, ]",
                                            },
                                          ],
                                          attrs: {
                                            placeholder:
                                              "请输入用于接收电子发票有效邮箱",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.valueaw == 1
                                      ? _c(
                                          "a-form-item",
                                          { attrs: { label: "购方名称" } },
                                          [
                                            _c("a-input", {
                                              directives: [
                                                {
                                                  name: "decorator",
                                                  rawName: "v-decorator",
                                                  value: [
                                                    "company",
                                                    {
                                                      rules: [
                                                        {
                                                          required: true,
                                                          message:
                                                            "请输入购买单位!",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                  expression:
                                                    "['company', { rules: [{ required: true, message: '请输入购买单位!' }] }]",
                                                },
                                              ],
                                              attrs: { disabled: "" },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.valueaw == 2
                                      ? _c(
                                          "a-form-item",
                                          { attrs: { label: "购方名称" } },
                                          [
                                            _c("a-input", {
                                              directives: [
                                                {
                                                  name: "decorator",
                                                  rawName: "v-decorator",
                                                  value: ["company"],
                                                  expression: "['company',]",
                                                },
                                              ],
                                              attrs: { disabled: "" },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.valueaw == 1
                                      ? _c(
                                          "a-form-item",
                                          { attrs: { label: "购方税号" } },
                                          [
                                            _c("a-input", {
                                              directives: [
                                                {
                                                  name: "decorator",
                                                  rawName: "v-decorator",
                                                  value: [
                                                    "yscode",
                                                    {
                                                      rules: [
                                                        {
                                                          required: true,
                                                          message:
                                                            "请输入统一社会信用代码!",
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                  expression:
                                                    "['yscode', { rules: [{ required: true, message: '请输入统一社会信用代码!' }] }]",
                                                },
                                              ],
                                              attrs: { disabled: "" },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.valueaw == 2
                                      ? _c(
                                          "a-form-item",
                                          { attrs: { label: "购方税号" } },
                                          [
                                            _c("a-input", {
                                              directives: [
                                                {
                                                  name: "decorator",
                                                  rawName: "v-decorator",
                                                  value: ["yscode"],
                                                  expression: "['yscode', ]",
                                                },
                                              ],
                                              attrs: { disabled: "" },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "地址、电话" } },
                                      [
                                        _c("a-input", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: ["address"],
                                              expression: "['address', ]",
                                            },
                                          ],
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "银行、账号" } },
                                      [
                                        _c("a-input", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: ["bank"],
                                              expression: "['bank',]",
                                            },
                                          ],
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticStyle: { "margin-top": "35px" } },
                        [
                          _c("a-col", { attrs: { span: 24 } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "500px",
                                  margin: "auto",
                                  "text-align": "center",
                                },
                              },
                              [
                                _c(
                                  "a-form",
                                  {
                                    attrs: {
                                      id: "ok",
                                      form: _vm.form,
                                      "label-col": { span: 5 },
                                      "wrapper-col": { span: 12 },
                                    },
                                  },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "       " } },
                                      [
                                        _c("a-checkbox", {
                                          staticStyle: {
                                            "margin-right": "10px",
                                          },
                                          on: { change: _vm.onChangeqw },
                                          model: {
                                            value: _vm.checked,
                                            callback: function ($$v) {
                                              _vm.checked = $$v
                                            },
                                            expression: "checked",
                                          },
                                        }),
                                        _vm._v(" 我已认真阅读并同意 "),
                                        _c(
                                          "span",
                                          {
                                            style: _vm.radioStyle,
                                            on: { click: _vm.boglook },
                                          },
                                          [_vm._v("服务协议")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "center",
                          },
                        },
                        [
                          _c(
                            "a-button",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                width: "200px",
                                height: "40px",
                                "font-size": "15px",
                              },
                              attrs: {
                                disabled: _vm.disabledlook,
                                type: "primary",
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [_vm._v(" 提交订单 ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "align-items": "center",
                            "justify-content": "center",
                          },
                          attrs: { id: "bottomtoolbar" },
                        },
                        [
                          _c(
                            "a-button",
                            {
                              staticStyle: {
                                "font-weight": "normal",
                                "font-size": "13px",
                                "margin-top": "20px",
                                background: "#5f9ea0",
                                color: "#fff",
                                "border-color": "#5f9ea0",
                              },
                              attrs: { id: "btnorder" },
                              on: { click: _vm.handleSubmits },
                            },
                            [_vm._v(" 查询订单 ")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "13px",
                                margin: "20px 10px 0",
                                background: "#FF9933",
                                color: "#fff",
                                "border-color": "#FF9933",
                              },
                              attrs: { id: "btnseal", type: "warning" },
                              on: {
                                click: function ($event) {
                                  _vm.dialogVisible = true
                                },
                              },
                            },
                            [_vm._v(" 智能图片处理 ")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: {
                                "font-weight": "normal",
                                "font-size": "13px",
                                "margin-top": "20px",
                                background: "#f0f2f5",
                                color: "#333",
                                "border-color": "#f0f2f5",
                              },
                              attrs: { id: "btnrefund", type: "warning" },
                              on: { click: _vm.handleSubmits },
                            },
                            [_vm._v(" 申请退款 ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            "close-on-click-modal": false,
                            "close-on-press-escape": false,
                            title: "智能图片处理",
                            visible: _vm.dialogVisible,
                            width: "30%",
                          },
                          on: {
                            "update:visible": function ($event) {
                              _vm.dialogVisible = $event
                            },
                          },
                        },
                        [
                          _c("div", { attrs: { id: "successbox" } }, [
                            _c("div", { staticClass: "infotip" }, [
                              _vm._v(
                                "在本系统下单购买证书后，须自行登录" +
                                  _vm._s(_vm.configdata.certplatformtitle) +
                                  "提交证书申请。 您可以"
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#1A53FF",
                                    cursor: "pointer",
                                  },
                                  on: { click: _vm.openyw },
                                },
                                [_vm._v("点击此处")]
                              ),
                              _vm._v(
                                "跳转到" +
                                  _vm._s(_vm.configdata.certplatformtitle) +
                                  "。 "
                              ),
                            ]),
                            _c("div", { staticClass: "infotip" }, [
                              _vm._v(
                                " 提交证书申请后，还须在" +
                                  _vm._s(_vm.configdata.certplatformtitle) +
                                  "提交电子签章所需的公章图片。专业的图像处理软件处理图章耗时且操作繁杂，如果您需要人工智能自动化图章处理（自主操作，使用简单，安全可靠，5秒出图），请 "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "red",
                                    cursor: "pointer",
                                  },
                                  on: { click: _vm.openseal },
                                },
                                [_vm._v("点击此处")]
                              ),
                              _vm._v(" 前往购买。"),
                            ]),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "dialog-footer",
                              attrs: { slot: "footer" },
                              slot: "footer",
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogVisible = false
                                    },
                                  },
                                },
                                [_vm._v("关 闭")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "阅读条款",
            visible: _vm.visible,
            width: "50%",
            destroyOnClose: true,
            "confirm-loading": _vm.confirmLoading,
            maskClosable: false,
          },
          on: { cancel: _vm.handleCancel },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { disabled: _vm.disabled, type: "primary" },
                      on: { click: _vm.handleOk },
                    },
                    [_vm._v(_vm._s(_vm.valiBtn))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "font-weight": "800" } },
            [_c("h1", [_vm._v("委托服务协议")])]
          ),
          _c("div", [
            _c("p", [
              _c("b", [
                _vm._v(
                  " 委托方：" +
                    _vm._s(_vm.companyname) +
                    "                                   信用代码：" +
                    _vm._s(_vm.companyyscode) +
                    " "
                ),
              ]),
            ]),
          ]),
          _c("div", [
            _c("p", [
              _c("b", [
                _vm._v("受托方：" + _vm._s(_vm.configdata.companytitle)),
              ]),
            ]),
          ]),
          _c("p", [
            _vm._v(
              "          鉴于：受托方系医保标准数字证书存储介质的授权提供商。委托方为了工作便利，自愿付费向受托方采购符合" +
                _vm._s(_vm.configdata.province) +
                "医保标准规范的数字证书存储介质（以下简称“KEY”），并委托受托方为其代为办理以下事宜："
            ),
          ]),
          _c("p", [
            _vm._v("          "),
            _c("b", [
              _vm._v("1、由受托方向相关管理单位申请灌装委托方医保数字证书；"),
            ]),
          ]),
          _c("br"),
          _c("p", [
            _vm._v("          "),
            _c("b", [
              _vm._v("2、受托方"),
              _vm.sendmethod == 1
                ? _c("b", [_vm._v("择优选择快递公司")])
                : _vm._e(),
              _vm._v("将灌装好的医保数字证书"),
              _vm.sendmethod == 1
                ? _c("b", [_vm._v("邮寄至委托方公司所在地。")])
                : _vm._e(),
              _vm.sendmethod == 2
                ? _c("b", [_vm._v("现场移交给委托方")])
                : _vm._e(),
            ]),
          ]),
          _c("br"),
          _c("p", [
            _vm._v("          服务有效期："),
            _c("b", [
              _vm._v("自签订本协议之日起至委托方收到医保数字证书之日止"),
            ]),
          ]),
          _c("br"),
          _c("p", [
            _vm._v(
              "         备注：灌装医保数字证书所需要的相关材料由委托方自行向相关管理单位提交，委托方收到灌装好的医保数字证书后自行保管KEY，若因委托方提交材料不合格导致无法或延期灌装，或KEY丢失、损坏等原因造成的损失由委托方自行承担。"
            ),
          ]),
          _c("br"),
          _c("p"),
          _c("br"),
          _c("p"),
          _c("br"),
          _c(
            "div",
            {
              staticStyle: {
                display: "block",
                overflow: "hidden",
                "margin-bottom": "25px",
                "padding-left": "70px",
                "box-sizing": "border-box",
              },
            },
            [
              _c("div", { staticStyle: { float: "left" } }, [
                _c("p", [
                  _vm._v("委托方："),
                  _c("b", [_vm._v(_vm._s(_vm.companyname))]),
                ]),
                _c("p", [
                  _vm._v("   日期："),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.year) +
                        "年" +
                        _vm._s(_vm.month) +
                        "月" +
                        _vm._s(_vm.dates) +
                        "日"
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    float: "right",
                    "padding-right": "70px",
                    "box-sizing": "border-box",
                  },
                },
                [
                  _c("p", [
                    _vm._v("受托方："),
                    _c("b", [_vm._v(_vm._s(_vm.configdata.companytitle))]),
                  ]),
                  _c("p", [
                    _vm._v("   日期："),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.year) +
                          "年" +
                          _vm._s(_vm.month) +
                          "月" +
                          _vm._s(_vm.dates) +
                          "日"
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "技术支持服务",
            visible: _vm.visiblelook,
            width: "50%",
            destroyOnClose: true,
            "confirm-loading": _vm.confirmLoading,
            maskClosable: false,
          },
          on: { cancel: _vm.handleCancellook },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { disabled: _vm.disabled, type: "primary" },
                      on: { click: _vm.handleOklook },
                    },
                    [_vm._v("同意购买技术服务")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "font-weight": "800" } },
            [_c("h1", [_vm._v("技术支持服务")])]
          ),
          _c("p", [
            _vm._v("          贵公司的技术支持服务截止时间为  "),
            _c("b", { staticStyle: { color: "red" } }, [
              _vm._v(_vm._s(_vm.outtime)),
            ]),
            _vm._v(
              "，技术支持服务已过期，为了方便您的使用，建议购买技术服务，技术支持服务收费标准："
            ),
            _c("b", { staticStyle: { color: "red" } }, [_vm._v("98元/年")]),
            _vm._v("。 "),
          ]),
          _c("p", [
            _vm._v(
              "          技术支持服务内容：数字证书使用咨询，数字证书使用问题处理。技术支持服务方式：电话或远程支持"
            ),
          ]),
          _c("p"),
          _c("br"),
          _c("p"),
          _c("br"),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: { width: "40%", title: "流程说明" },
          on: { ok: _vm.handleOkmodd },
          model: {
            value: _vm.visiblemodd,
            callback: function ($$v) {
              _vm.visiblemodd = $$v
            },
            expression: "visiblemodd",
          },
        },
        [
          _c("p", [
            _c("b", [
              _vm._v(
                "灌装流程说明：企业在此下单后，请再自行前往证书运维管理平台上提交证书申请。"
              ),
            ]),
          ]),
          _c("p", [_vm._v("Some contents...")]),
          _c("p", [_vm._v("Some contents...")]),
        ]
      ),
      _c("pay-test-modal", {
        ref: "payTestModal",
        on: {
          closeBarCode: function ($event) {
            _vm.$refs.payTestBarCode.visible = false
          },
        },
      }),
      _c("pay-test-bar-code", {
        ref: "payTestBarCode",
        on: {
          barCodeValue: _vm.barCodeChange,
          CodeAgainChange: _vm.testCodeChange,
        },
      }),
      _vm.sssvisiblesss
        ? _c("div", { staticClass: "position" }, [
            _c("div", { staticClass: "position_cont" }, [
              _c("div", { staticClass: "position_conttit" }, [
                _vm._v("购买须知"),
              ]),
              _c("div", { staticClass: "position_content" }, [
                _vm._v(_vm._s(_vm.configdata.notice)),
              ]),
              _c("div", { staticClass: "position_contbot" }, [
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.handleCancesl },
                  },
                  [_vm._v(" " + _vm._s(_vm.buttso) + " ")]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.Tips
        ? _c("div", { staticClass: "position" }, [
            _c("div", { staticClass: "position_cont" }, [
              _c("div", { staticClass: "position_conttit" }, [
                _vm._v("温馨提示"),
              ]),
              _c("div", { staticClass: "position_content" }, [
                _vm._v(
                  "省心服务可以帮您提供申请、罐装、邮寄的一站式服务，放弃省心服务可能无法及时获得CA证书，请再次确认是否放弃订购！"
                ),
              ]),
              _c("div", { staticClass: "position_contbot" }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      cursor: "pointer",
                      "margin-right": "15px",
                      background: "#eeeeee",
                    },
                    on: { click: _vm.handleCanceslgiveup },
                  },
                  [_vm._v("放弃订购")]
                ),
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer", background: "#67c23a" },
                    on: { click: _vm.handleCanceslcontinue },
                  },
                  [_vm._v("继续订购")]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            background: "#f0f2f5",
            height: "100px",
            "text-align": "center",
            "justify-content": "center",
            width: "100%",
            display: "flex",
            "flex-direction": "row",
            "align-items": "center",
          },
        },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("img", {
              staticStyle: { "margin-right": "10px" },
              attrs: { src: _vm.policeimg },
            }),
            _vm._v(" " + _vm._s(_vm.configdata.sitebeian)),
          ]),
          _c("div", { staticStyle: { width: "50px" } }),
          _c(
            "div",
            [
              _c("a-icon", {
                style: { fontSize: "14px", color: "#08c" },
                attrs: { type: "mail", theme: "twoTone" },
              }),
              _vm._v(" 邮箱："),
              _c(
                "b",
                {
                  staticStyle: { color: "#1890ff", cursor: "pointer" },
                  on: { click: _vm.youxiang },
                },
                [_vm._v(_vm._s(_vm.configdata.maile))]
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { width: "50px" } }),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _c("b", { staticStyle: { "margin-right": "5px" } }, [
              _vm._v("客服电话 "),
            ]),
            _vm._v("："),
            _c("span", { staticStyle: { color: "rgb(24, 144, 255)" } }, [
              _vm._v(_vm._s(_vm.configdata.servicephone)),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "column",
            position: "fixed",
            right: "25px",
            bottom: "150px",
            width: "100px",
            overflow: "hidden",
            cursor: "pointer",
          },
          on: { click: _vm.Gokefu },
        },
        [
          _c("img", {
            staticStyle: {
              width: "100px",
              height: "90px",
              margin: "10px auto 10px",
            },
            attrs: { src: _vm.icon_ren },
          }),
          _c(
            "span",
            {
              staticStyle: {
                display: "block",
                "text-align": "center",
                margin: "0 auto",
                width: "80px",
                height: "30px",
                "line-height": "30px",
                "font-size": "14px",
                color: "#fff",
                background: "rgb(24, 144, 255)",
                "border-radius": "5px",
              },
            },
            [_vm._v("在线客服")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }